module.exports = __webpack_public_path__ + "static/media/Bills_header_favorites.78bbe59c.svg";